import type { ApiPhoneCall } from '../api/types';

export function reduceCachedPhoneCall(phoneCall: ApiPhoneCall | undefined): ApiPhoneCall | undefined {
  if (!phoneCall || phoneCall.state === 'discarded') {
    return undefined;
  }

  return {
    id: phoneCall.id,
    adminId: phoneCall.adminId,
    participantId: phoneCall.participantId,
    state: phoneCall.state,
    ...(phoneCall.accessHash ? { accessHash: phoneCall.accessHash } : {}),
    ...(phoneCall.isVideo !== undefined ? { isVideo: phoneCall.isVideo } : {}),
    ...(phoneCall.isConnected !== undefined ? { isConnected: phoneCall.isConnected } : {}),
    ...(phoneCall.protocol ? { protocol: phoneCall.protocol } : {}),
    ...(phoneCall.reason ? { reason: phoneCall.reason } : {}),
    ...(phoneCall.date !== undefined ? { date: phoneCall.date } : {}),
    ...(phoneCall.receiveDate !== undefined ? { receiveDate: phoneCall.receiveDate } : {}),
  };
}
